import { AriaDescriber, FocusMonitor } from "@angular/cdk/a11y";
import { Directionality } from "@angular/cdk/bidi";
import { Overlay, ScrollDispatcher } from "@angular/cdk/overlay";
import { Platform } from "@angular/cdk/platform";
import {
  Directive,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Optional,
  ViewContainerRef,
} from "@angular/core";
import {
  MatTooltip,
  MatTooltipDefaultOptions,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY,
} from "@angular/material";
import { Subscription } from "rxjs";
import {
  ConfiguracionPersonalizacion,
  PersonalizacionDataService,
} from "src/app/core/services/personalizacion-data.service";

@Directive({
  selector: "[ayudaPantalla]",
  exportAs: "ayudaPantalla",
})
export class AyudaPantallaDirective
  extends MatTooltip
  implements OnInit, OnDestroy {
  private suscripciones: Subscription[];

  constructor(
    _overlay: Overlay,
    _elementRef: ElementRef,
    _scrollDispatcher: ScrollDispatcher,
    _viewContainerRef: ViewContainerRef,
    _ngZone: NgZone,
    _platform: Platform,
    _ariaDescriber: AriaDescriber,
    _focusMonitor: FocusMonitor,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) _scrollStrategy: any,
    @Optional() _dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    _defaultOptions: MatTooltipDefaultOptions,
    private personalizacionDataService: PersonalizacionDataService
  ) {
    super(
      _overlay,
      _elementRef,
      _scrollDispatcher,
      _viewContainerRef,
      _ngZone,
      _platform,
      _ariaDescriber,
      _focusMonitor,
      _scrollStrategy,
      _dir,
      _defaultOptions
    );
    this.disabled = true;
    this.suscripciones = [];
  }

  ngOnInit(): void {
    this.suscripciones.push(
      this.personalizacionDataService.configuracion.subscribe(
        (configuracion: ConfiguracionPersonalizacion) => {
          this.disabled = !configuracion.ayudaEnPantalla;
        }
      )
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.suscripciones.forEach((suscripcion) => {
      suscripcion.unsubscribe();
    });
  }

  @Input("ayudaPantalla")
  get tooltip() {
    return this.message;
  }

  set tooltip(value: string) {
    this.message = value;
  }
}
